<template>
	<div>
        <el-card shadow="never" v-if="!spaceId">
            <el-alert
            class="app-btn-group"
            :title="$t('prompt_message')"
            type="info"
            :closable="false"
            :description="$t('command_template_select_space')"
            show-icon></el-alert>
            <div class="app-btn-group">
                <el-button type="primary" @click="switchSpaceHandler" icon="el-icon-refresh" size="small">{{ $t('select_project_space') }}</el-button>
            </div>
            <div class="app-divider"></div>
        </el-card>

	    <el-card shadow="never" v-else>
            <div class="app-btn-group">
                <el-button type="primary" @click="switchSpaceHandler" icon="el-icon-refresh" size="small">{{ $t('switch_project_space') }}</el-button>
            </div>
            <div class="app-btn-group" style="min-height: 30px">
                <div v-loading="spaceLoading">
                    <h4>{{ this.spaceDetail.name }}</h4>
                    <p class="app-description">{{ this.spaceDetail.description }}</p>
                </div>
            </div>


            <el-row class="app-btn-group">
            	<el-col :span="4">
            		<el-button v-if="$root.CheckPriv($root.Priv.COMMAND_TEMPLATE_NEW)" @click="openAddDialogHandler" type="primary" size="medium" icon="iconfont left small icon-add">{{ $t('add_command_template') }}</el-button>&nbsp;
            	</el-col>
            	<el-col :span="6" :offset="14">
            		<el-input @keyup.enter.native="searchHandler" v-model="searchInput" size="medium" :placeholder="$t('input_name_to_search')">
                        <el-button @click="searchHandler" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
            	</el-col>
            </el-row>

            <el-table
                class="app-table"
                size="medium"
                v-loading="tableLoading"
                :data="tableData">
                <el-table-column prop="name" :label="$t('command_template')">
                    <div slot-scope="scope" class="app-table-explain">
                        <h4>{{ scope.row.name }}</h4>
                        <p class="app-description">{{ scope.row.description }}</p>
                    </div>
                </el-table-column>
                
                <el-table-column align="center" prop="need_audit" width="150" :label="$t('open_audit')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.need_audit == 1">{{ $t('yes') }}</span>
                        <span v-else>{{ $t('no') }}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="status" width="120" :label="$t('command_template_enable')">
                    <template slot-scope="scope">
                        <el-switch
                        v-if="$root.CheckPriv($root.Priv.PROJECT_AUDIT)"
                        @change="enableSwitchHandler($event, scope.row)"
                        v-model="scope.row.status"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#13ce66">
                        </el-switch>
                        <span style="margin-left: 5px;" v-if="scope.row.status">{{ $t('have_enabled') }}</span>
                        <span style="margin-left: 5px;" v-else>{{ $t('not_enable') }}</span>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('operate')" width="180" align="right">
                    <template slot-scope="scope">
                        <el-button
                        v-if="$root.CheckPriv($root.Priv.COMMAND_TEMPLATE_EDIT)"
                        icon="el-icon-edit"
                        type="text"
                        @click="openEditDialogHandler(scope.row)">{{ $t('edit') }}</el-button>
                        <el-button
                        v-if="$root.CheckPriv($root.Priv.COMMAND_TEMPLATE_DEL)"
                        type="text"
                        icon="el-icon-delete"
                        class="app-danger"
                        @click="deleteHandler(scope.row)">{{ $t('delete') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                class="app-pagination"
                @current-change="currentChangeHandler"
                :current-page.sync="$root.Page"
                :page-size="$root.PageSize"
                :total="$root.Total">
            </el-pagination>


	    </el-card>


        <el-dialog :width="$root.DialogNormalWidth" :title="dialogTitle" :visible.sync="dialogVisible" @close="dialogCloseHandler">
            <div class="app-dialog" v-loading="dialogLoading">
                <el-form ref="dialogRef" :model="dialogForm" size="medium" label-width="120px">
                    <el-form-item 
                        :label="$t('command_template_name')"
                        prop="name"
                        :rules="[
                            { required: true, message: $t('name_cannot_empty'), trigger: 'blur'},
                        ]">
                        <el-input v-model="dialogForm.name" autocomplete="off"></el-input>
                    </el-form-item>
                    
                    <el-form-item
                    :label="$t('open_audit')"
                    prop="need_audit"
                    >
                        <div>
                            <el-switch
                            v-model="dialogForm.need_audit"
                            :active-value="1"
                            :inactive-value="0"
                            active-color="#13ce66">
                            </el-switch>
                            <span style="margin-left: 8px;">
                                <span v-if="dialogForm.need_audit">{{ $t('open') }}</span>
                                <span v-else>{{ $t('close') }}</span>
                            </span>
                        </div>
                        <div class="app-form-explain">{{ $t('if_open_apply_need_audit') }}</div>
                    </el-form-item>

                    <el-form-item 
                    :label="$t('user')"
                    prop="execute_user"
                    :rules="[
                        { required: true, message: $t('user_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input class="app-input-mini" :placeholder="$t('execute_user')" v-model="dialogForm.execute_user" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item 
                    :label="$t('command')"
                    prop="command">
                        <el-input :placeholder="$t('command_tips')" type="textarea" :rows="3" v-model="dialogForm.command" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item 
                    :label="$t('online_host')"
                    prop="online_host">
                        <el-input :placeholder="$t('online_host_tips')" type="textarea" :rows="3" v-model="dialogForm.online_host" autocomplete="off"></el-input>
                    </el-form-item>


                    <el-form-item 
                    :label="$t('online_cluster')"
                    prop="online_cluster"
                    :rules="[
                        { required: true, message: $t('online_cluster_cannot_empty'), trigger: 'blur' },
                    ]">
                        <el-select
                        class="app-input-mini"
                        v-model="selectOnlineCluster"
                        filterable
                        clearable
                        @change="selectClusterHandler"
                        :placeholder="$t('please_input_keyword')">
                            <el-option
                            v-for="cluster in clusterList"
                            :key="cluster.id"
                            :label="cluster.name"
                            :value="cluster.id">
                            </el-option>
                        </el-select>
                        <div v-if="dialogForm.online_cluster && dialogForm.online_cluster.length">
                            <span>{{ $t('selected_cluster_list') }}</span>
                            <ul class="app-form-box">
                                <li class="item" v-for="id in dialogForm.online_cluster" :key="id">
                                    <span><i class="iconfont small left icon-cluster"></i>{{ formatClusterName(id) }}</span>
                                    <span>
                                        <el-button @click="removeClusterHandler(id)" icon="el-icon-delete" type="text">{{ $t('remove') }}</el-button>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </el-form-item>


                    <el-form-item 
                        :label="$t('description')"
                        prop="description">
                        <el-input type="textarea" :rows="6" v-model="dialogForm.description" autocomplete="off"></el-input>
                    </el-form-item>


                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="dialogCloseHandler">{{ $t('cancel') }}</el-button>
                    <el-button :loading="btnLoading" size="small" type="primary" @click="dialogSubmitHandler">{{ $t('enter') }}</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog 
        :width="$root.DialogSmallWidth"
        :visible.sync="dialogSpaceVisible"
        :title="$t('select_project_space')">
            <div style="padding-bottom: 50px;">
                <el-select filterable @change="selectSpaceHandler" v-model="spaceId" style="width: 100%;" size="small" :placeholder="$t('select_project_space')">
                    <el-option v-for="s in spaceList" :key="s.id" :value="s.id" :label="$root.Substr(s.name, 50)" ></el-option>
                </el-select>
            </div>
        </el-dialog>

	</div>
</template>

<script>
import {
    TemplateSubmitApi,
    TemplateDetailApi,
    TemplateUpdateApi,
    TemplateListApi,
    TemplateDeleteApi,
} from '@/api/command.js'

import {
    detailSpaceApi,
    listSpaceApi,
} from '@/api/project.js'

export default {
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            dialogSpaceVisible: false,
            searchInput: '',
            spaceList: [],
            clusterList: [],
            tableLoading: false,
            tableData: [],
            spaceId: undefined,
            dialogForm: {
                id: 0,
                name: '',
                description: '',
                need_audit: 0,
                online_cluster: [],
                online_host: '',
                execute_user: '',
                command: '',
                deploy_notice: '',
                status: 0,
            },
            spaceDetail: {},
        }
    },

    watch: {
        spaceId() {
            if (this.spaceId) {
                this.spaceLoading = true
                detailSpaceApi({id: this.spaceId}).then(res => {
                    this.spaceDetail = res
                    this.spaceLoading = false
                }).catch(err => {
                    this.spaceLoading = false
                })
                this.$root.PageInit()
                this.loadTableData()
            }
        }
    },

    methods: {
        loadTableData() {
            this.tableLoading = true
            cmdTemplateListApi({space_id: this.spaceId, keyword: this.searchInput, offset: this.$root.PageOffset(), limit: this.$root.PageSize}).then(res => {
                this.tableData = res.list
                this.$root.Total = res.total
                this.tableLoading = false
            }).catch(err => {
                this.tableLoading = false
            })
        },

        openAddDialogHandler() {
            this.dialogVisible = true
            this.dialogTitle = this.$t('add_command_template')
        },

        dialogCloseHandler() {
            this.dialogVisible = false
            this.dialogLoading = false
            this.btnLoading = false
            this.$refs.dialogRef.resetFields();
            this.dialogForm = {}
        },

        switchSpaceHandler() {
            this.dialogSpaceVisible = true
        },
        selectSpaceHandler() {
            this.dialogSpaceVisible = false
        },
        switchSpaceHandler() {
            this.dialogSpaceVisible = true
        },
        loadSpaceList() {
            listSpaceApi({offset: 0, limit: 999}).then(res => {
                if (res.list) {
                    this.spaceList = res.list
                }
                this.initSpaceId()
            })
        },
        initSpaceId() {
            if (this.spaceList.length && !this.spaceId) {
                this.spaceId = this.spaceList[0].id
            }
        },

    },


    mounted() {
        this.loadSpaceList()
        this.loadClusterList()
    }

}
</script>
